import { lazy } from 'react';


export const CookiesPolicy = lazy(() => import('./CookiesPolicy'));
